import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../utils/axios";
import {
  MilestonesApiResponse,
  MilestonesResponse,
} from "../types/milestones-types";

export const fetchMilestones = createAsyncThunk(
  "milestones/fetchMilestones",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get<MilestonesApiResponse>(
        "/milestones?populate=*"
      );
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

type MilestonesState = {
  milestones: MilestonesResponse[];
  status: "idle" | "loading" | "succeeded" | "failed";
  error: string | null;
};

const initialState: MilestonesState = {
  milestones: [],
  status: "idle",
  error: null,
};

const milestonesSlice = createSlice({
  name: "milestones",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchMilestones.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchMilestones.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.milestones = action.payload.data;
      })
      .addCase(fetchMilestones.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload as string;
      });
  },
});

export default milestonesSlice.reducer;
